import {GatsbyBrowser} from 'gatsby'

import {setParamCookies} from '@helios/shared/config/param-cookies'
import {page} from '@helios/shared/utils/analytics'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => {
    if (!('ontouchstart' in document.documentElement)) {
        document.documentElement.classList.add('no-touch')
    }

    if (location.search) {
        setParamCookies(location.search)
    }

    // The page path without the locale segment, e.g. `/pricing` instead of `/en/pricing`
    const rawPath = `/${location.pathname.split('/').slice(2).join('/')}`

    page({
        rawPath,
    })
}
